module.exports = __webpack_public_path__ + "img/GitHub-Mark-120px-plus.ef7a02b6.png";